import okta from 'constants/okta';
import { parseJwt } from 'utils/jwtToken';
import isEmpty from 'lodash/isEmpty';

const getOktaTokens = () => {
  const oktaTokensStr = localStorage.getItem(okta.OKTA_TOKEN_STORAGE);
  return JSON.parse(oktaTokensStr || '{}');
};

export const isTokenAvailable = () =>
  !isEmpty(getOktaTokens()) &&
  !isEmpty(getOktaTokens().accessToken) &&
  !isEmpty(getOktaTokens().idToken);
export const getAccessToken = () => getOktaTokens().accessToken;
export const getIdToken = () => getOktaTokens().idToken;
export const getTokenExpirationDate = () => getOktaTokens().accessToken.expiresAt * 1000;

export const getAccessTokenJWT = () => getAccessToken()?.accessToken;
export const getIdTokenJWT = () => getIdToken().idToken;

export const getOktaUser = () => parseJwt(getIdTokenJWT());
export const getOktaUserId = () => getOktaTokens().accessToken.claims.uid;
export const getUserFromToken = () => {
  if (!isTokenAvailable()) return null;
  const oktaUser = getOktaUser();
  return { email: oktaUser.email, name: oktaUser.name, uid: oktaUser.sub };
};
